import { render, staticRenderFns } from "./SortModifiers.vue?vue&type=template&id=19269a36&lang=pug"
import script from "./SortModifiers.vue?vue&type=script&lang=js"
export * from "./SortModifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports